import { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setOffset } from 'redux/mode/actions';
import { RootReducer } from 'redux/reducers';
import { Point } from 'dragonmouse-shared/geometry';
import * as S from './styles';
import { selectTransform } from 'redux/mode/reducers';

const HandTool = () => {
	const dispatch = useDispatch();

	const [mouseClickPos, setMouseClickPos] = useState<Point>({ x: 0, y: 0 });
	const [mouseClickOffset, setMouseClickOffset] = useState<Point>({ x: 0, y: 0 });
	const [mouseDown, setMouseDown] = useState<boolean>(false);

	const { offset } = useSelector(
		(r: RootReducer) => ({
			offset: selectTransform(r.mode).offset,
		}),
		shallowEqual
	);

	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------
	const onMouseDown = (e: any) => {
		setMouseClickOffset(offset);
		setMouseClickPos({ x: e.pageX, y: e.pageY });
		setMouseDown(true);
	};

	const onMouseUp = (e: any) => {
		if (e as MouseEvent) {
			setMouseDown(false);
		}
	};

	const onMouseMove = (e: any) => {
		if (e as MouseEvent) {
			if (mouseDown) {
				const dx = e.pageX - mouseClickPos.x;
				const dy = e.pageY - mouseClickPos.y;
				dispatch(
					setOffset({
						x: mouseClickOffset.x + dx,
						y: mouseClickOffset.y + dy,
					})
				);
			}
		}
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<S.Base
			onMouseUp={onMouseUp}
			onMouseDown={onMouseDown}
			onMouseMove={onMouseMove}
			cursor={mouseDown ? 'grabbing' : 'grab'}
		></S.Base>
	);
};

export default HandTool;
